import React from 'react';

import { IObjectDropdown } from '../../types/IObjectDropdown';

import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import './dashboardObjectPicker.scss';
//this needs to change. should not have a single component handling 3 different drop downs
const DashboardObjectPicker: React.FC<IObjectDropdown> = ({
                                                            onObjectChangeCallback,
                                                            dataArray,
                                                            type,
                                                            className,
                                                            selectedCurrency,
                                                            selectedObject,
                                                            selectedPeriod
                                                          }) => {
  const handleObjectChange = (event: DropDownListChangeEvent) => {
    onObjectChangeCallback(event);
  };

  const getDefaultValue = () => {
    return type === 'periods' ? (selectedPeriod || dataArray[dataArray.length - 1]) :
      (type === 'objects' && selectedObject) ? dataArray.find((item) => {
        return item.objectPath === selectedObject.objectPath;
      }) : null;
  };

  const getTextField = () => {
    return type === 'currencies' ? 'currencyShortName' : 'name';
  };

  const getDataItemKey = () => {
    return type === 'currencies' ? 'currency' : 'id';
  };

  return (
    <div className={`object-dropdown-wrapper ${className ? className : ''}`}>
      {type === 'currencies' ?
        <DropDownList data={dataArray}
                      className='custom-dropdown-style'
                      value={selectedCurrency}
                      onChange={handleObjectChange}
                      textField={getTextField()}
                      dataItemKey={getDataItemKey()} />
        : (type === 'periods' ?
          <DropDownList data={dataArray}
                        className='custom-dropdown-style'
                        defaultValue={getDefaultValue()}
                        value={selectedPeriod}
                        onChange={handleObjectChange}
                        textField={getTextField()}
                        dataItemKey={getDataItemKey()} /> :
          <DropDownList data={dataArray}
                        className='custom-dropdown-style'
                        defaultValue={getDefaultValue()}
                        onChange={handleObjectChange}
                        textField={getTextField()}
                        dataItemKey={getDataItemKey()} />)}
    </div>
  );
};

export default DashboardObjectPicker;
